/* prettier-ignore */

/**
 * HRS-3471: CMS image-variant contract.
 *
 * The CMS (`FileTrait.php`) converts every processed upload to WebP and writes
 * width variants next to the original as `{base}-w{N}.webp`. Live probes
 * (2026-09-24, madrid/fuengirola production) confirmed that `w200`/`w350` exist
 * for most processed images, `w800` only when the source is wider than 800px,
 * `w1200` almost never, and that some tenants have no variants at all (every
 * srcset render must therefore survive a missing candidate).
 */

/** Standard candidate widths the CMS generates (`w1200` deliberately excluded: it barely exists). */
export const IMAGE_VARIANT_WIDTHS = [200, 350, 500, 800] as const;

/** Width `RestService.addThumbnail` requests when the call site does not ask for another one. */
export const DEFAULT_IMAGE_VARIANT_WIDTH = 350;

/** Only CMS-processed uploads served under `/storage/` have variants. */
export const CMS_STORAGE_PATH = '/storage/';

/** Processed originals are always WebP; anything else (external, as-is uploads) has no variants. */
export const WEBP_EXTENSION_REGEX = /\.webp$/i;

/** Matches a path that is already a variant (`-w350.webp`), so it is never re-suffixed. */
export const VARIANT_SUFFIX_REGEX = /-w\d+\.webp$/i;

/** CMS placeholder returned when a resource has no image; `addThumbnail` maps it to `null`. */
export const PLACEHOLDER_FILENAME = 'default.webp';

/** Declared srcset descriptor of the original in hero presets (CMS main-image resolution cap). */
export const ORIGINAL_DECLARED_WIDTH = 1920;

/** Local image shown when every remote source failed (last step of every fallback chain). */
export const LOCAL_DEFAULT_IMAGE = '/assets/imgs/imageDefault.png';
